import { Dictionary } from "flow/api/types";
import config from "flow/config";
import environment from "flow/configuration/environment";

const overridableKeys = [
    environment.keys.debug,
    environment.keys.debugEvents,
    environment.keys.debugInactivity,
    environment.keys.debugOrder,
    environment.keys.ignoreBootErrors,
    environment.keys.inspector,
    environment.keys.themeSelector
];

function getOverridesFromSessionStorage(): Dictionary<boolean> {
    try {
        const storedValuesString = sessionStorage.getItem(config.storageKeys.urlOverrides);
        if (storedValuesString) {
            const storedOverrides = JSON.parse(storedValuesString);

            const cleanedUpOverrides = Object.fromEntries(
                Object.entries(storedOverrides).filter(([key]) => overridableKeys.includes(key))
            );

            return cleanedUpOverrides as Dictionary<boolean>;
        }

        return {};
    } catch (_e) {
        return {};
    }
}

function storeOverridesInSessionStorage(overrides: Dictionary<boolean>): void {
    if (Object.keys(overrides).length === 0) {
        return;
    }

    sessionStorage.setItem(config.storageKeys.urlOverrides, JSON.stringify(overrides));
}

function getOverridesFromUrl(): Dictionary<boolean> {
    const overridesFromUrl: Dictionary<boolean> = {};
    const searchParams = new URLSearchParams(window.location.search);
    overridableKeys.forEach(key => {
        const value = searchParams.get(key);
        if (value === "true") {
            overridesFromUrl[key] = true;
        } else if (value === "false") {
            overridesFromUrl[key] = false;
        }
    });

    return overridesFromUrl;
}

function applyOverridesToEnvironment(overrides: Dictionary<boolean>): void {
    Object.keys(overrides).forEach(key => {
        environment.set(key, overrides[key]);
    });
}

export function applyEnvironmentOverridesFromUrlAndSessionStorage(): void {
    const overrides = { ...getOverridesFromSessionStorage(), ...getOverridesFromUrl() };
    applyOverridesToEnvironment(overrides);
    storeOverridesInSessionStorage(overrides);
}
